import React from 'react';
import { Container, Typography, Box, Alert } from '@mui/material';
import TeacherNavbar from './TeacherNavbar'; // Import the TeacherNavbar component
import './DashboardLayout.css'; // Import the layout styles
import TeacherEnglishBoundary from './TeacherEnglishBoundary';

const TeacherDashboard = () => {
    return (
        <TeacherEnglishBoundary><div className="dashboard-layout">
            <TeacherNavbar />
            <Container className="dashboard-teacher-content">
                <Box sx={{ my: 4 }}>
                    <Typography variant="h4" component="h1" gutterBottom>
                        Teacher Dashboard
                    </Typography>
                    <Typography variant="body1">
                        Welcome to your teacher dashboard! Here you can manage your courses, view student progress, and more.
                    </Typography>
                    <Alert severity="info" sx={{ mt: 2 }}>
                        Please use English while working in the teacher dashboard. Deutsch: Bitte derzeit auf Englisch arbeiten.
                    </Alert>
                </Box>
            </Container>
        </div></TeacherEnglishBoundary>
    );
};

export default TeacherDashboard;
